export const formatPriceWithCurrency = (price, currency = 'ILS') => {
    if (price === null || price === undefined || isNaN(price)) {
        return '-'
    }

    const formattedPrice = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(price)

    const currencySymbol = currency === 'USD' ? '$' : '₪'

    return `${currencySymbol} ${formattedPrice}`
}

export const getCurrencySymbol = (currency = 'ILS') => {
    return currency === 'USD' ? '$' : '₪'
}

export default formatPriceWithCurrency


